import * as Sentry from "@sentry/react";
import { useCallback, useMemo, useState } from "react";

// todo d1 improve types here?
export function useApi<T extends (...args: any[]) => any | null>(apiCall: T) {
	const [loading, setLoading] = useState(false);

	const request = useCallback(
		async (...args: Parameters<T>) => {
			setLoading(true);
			try {
				return await apiCall(...args);
			} catch (e) {
				console.error(`API call ${apiCall.name || "<anonymous>"} failed:`, e);
				Sentry.captureException(e);
				return null;
			} finally {
				setLoading(false);
			}
		},
		[apiCall],
	);

	return useMemo(() => {
		return { loading, request } as { loading: boolean; request: T };
	}, [loading, request]);
}
